import { render, staticRenderFns } from "./TablaGeneral.vue?vue&type=template&id=690d8ec4&"
import script from "./TablaGeneral.vue?vue&type=script&lang=js&"
export * from "./TablaGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports